import Base from "../base/Base";

export default function Menu(name, path, active = false, icon = null, children = []) {

	//extend Base's Attributes.
	Base.call(this, arguments);

	this.name = name;
	this.active = active;
	this.icon = icon;
	this.router = {
		path: path
	};
	this.children = children;
	this.articleId = null;
	this.parent = null;
}


//extend Base's methods.
Menu.prototype = new Base();
Menu.prototype.constructor = Menu;

Menu.prototype.add = function (menu) {
	menu.parent = this.router.path;
	this.children.push(menu);
}




// WEBPACK FOOTER //
// ./src/common/model/lover/Menu.js